import CheckOutlayPage from './CheckOutlayPage'
export default CheckOutlayPage


// WEBPACK FOOTER //
// ./src/pages/outlay/check/index.js